import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldScreensRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-screens',
	path: '/jira/settings/issues/screens',
};
